// Field team reporting status — the tracking-side status shown as "Field Report
// Status" on the reporting boards. Extracted from the inline switch in
// reporting/FieldTeamStatusBoard so the Site Visit Summary renders the exact
// same pills (classNames are the global ones defined in Implementation.scss).
export const fieldTeamReportingStatusEnum = {
  1: { text: "Data collection", className: "dataCollection", fill: "#3B81FE" },
  2: { text: "Data check", className: "dataCheck", fill: "#045B46" },
  3: {
    text: "Field Reporting writing",
    className: "fieldReportWriting",
    fill: "var(--Range-assessment-Excellent, #3D9B4C)",
  },
  4: { text: "Translation", className: "translation", fill: "#918d27" },
  5: {
    text: "Field Reporting Completed",
    className: "fieldReportCompleted",
    fill: "#9670b8",
  },
  6: {
    text: "Field report approved",
    className: "fieldReportApproved",
    fill: "var(--Graph-Green-1, #06768E)",
  },
  7: {
    text: "Field report submitted to client",
    className: "fieldReportSubmitted",
    fill: "var(--Graph-Green-3, #6FC5D5)",
  },
  default: {
    text: "Unknown",
    className: "noStatus",
    fill: "rgba(172, 12, 12, 0.777)",
  },
};

export const getFieldTeamReportingStatus = (status) =>
  fieldTeamReportingStatusEnum[status] || fieldTeamReportingStatusEnum.default;
